import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import './styles/tokens.css';
import './styles/reset.css';
import './styles/components.css';
import './styles/pages.css';
import '@aws-amplify/ui-react/styles.css';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID as string,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID as string,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_AUTH_DOMAIN as string,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [window.location.origin + '/dashboard'],
          redirectSignOut: [window.location.origin + '/login'],
          responseType: 'code',
          providers: ['Google', { custom: 'LinkedIn' }],
        },
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
